import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../endpoint";
import type { OrgTreeResponse, OrgTreeParams } from "../types";


export const fetchOrgTree = async (params: OrgTreeParams = {}): Promise<OrgTreeResponse> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.ORG_MANAGEMENT.TREE, {
    params: {
      page: params.page ?? 1,
      limit: params.limit ?? 20,
      organizationId: params.organizationId,
      includeIndependent: params.includeIndependent === false ? false : undefined,
    },
  });
  return data;
};